import ContactFloatingButton from './ContactFloatingButton'

export default function SkillsPlanning() {
  return (
    <div>
      {/* 기획 - 복잡하게만 느껴지는 홈페이지 */}
      <div className='container mx-auto bg-sk-white max-md:px-20'>
        <div className='flex items-start justify-between py-48 sm:py-64 sm:items-center max-sm:flex-col sm:flex max-sm:gap-12'>
          <div className='flex flex-col items-start gap-6'>
            <p className='text-h2-medium sm:text-h1-medium text-sk-info'>기획</p>
            <p className='text-title3-bold lg:text-title2-bold 2xl:text-title1-bold text-sk-default'>
              복잡하게만 느껴지는 홈페이지,
              <br />
              필요기능을 정리하고 보기 쉽게 정리해드려요
            </p>
          </div>
        </div>
      </div>
      {/* 사례 */}
      <div className='container flex items-start justify-center gap-40 mx-auto max-sm:flex-col py-60 sm:py-80 bg-sk-white max-md:px-20'>
        <div className='flex flex-col items-start gap-32'>
          <img src={require('assets/images/skills-planning_ex1.png')} alt='' />
          <div className='flex flex-col items-start gap-16'>
            <div className='flex flex-col items-start gap-4'>
              <p className='text-body1-medium sm:text-h2-medium text-sk-info'>고객 사례</p>
              <p className='text-h1-semibold 2xs:text-title3-bold sm:text-title2-bold text-sk-default'>
                AI 대변인
              </p>
            </div>
            <p className='text-body1-medium sm:text-h2-medium text-sk-default'>
              AI에 대한 높은 이해도를 바탕으로
              <br />
              서비스 및 정보구조도 기획이 가능합니다
            </p>
          </div>
        </div>
        <div className='flex flex-col items-start gap-32'>
          <img src={require('assets/images/skills-planning_ex2.png')} alt='' />
          <div className='flex flex-col items-start gap-16'>
            <div className='flex flex-col items-start gap-4'>
              <p className='text-body1-medium sm:text-h2-medium text-sk-info'>시그마 사례</p>
              <p className='text-h1-semibold 2xs:text-title3-bold sm:text-title2-bold text-sk-default'>
                대시보드/관리자 페이지
              </p>
            </div>
            <p className='text-body1-medium sm:text-h2-medium text-sk-default'>
              서비스 운영에 필요한 데이터 시각화 및 설정, 관리 기능에{' '}
              <br className='hidden 2xs:block' />
              특화된 UXUI 기획이 가능합니다
            </p>
          </div>
        </div>
      </div>
      {/* Site Map */}
      <div className=' skills_background1 pt-[38px]'>
        <div className='container flex items-center justify-center px-20 mx-auto'>
          <img src={require('assets/images/skills-planning_sitemap.png')} alt='' />
        </div>
      </div>
      {/* 하나의 키워드에 필요한 ~ */}
      <div className='flex skills_background2 h-[600px] sm:h-[800px] flex-col justify-center mb-[-220px] sm:mb-[-260px]'>
        <div className='container xl:absolute xl:right-0 flex items-center justify-end gap-64 mx-auto max-md:flex-col-reverse z-[9] max-lg:px-20 overflow-x-hidden'>
          <div className='flex flex-col items-start gap-24'>
            <p className='text-h1-semibold 2xs:text-title3-bold sm:text-title2-bold text-sk-default'>
              하나의 키워드에 필요한
              <br />
              수많은 기능을 연계해서 알려드립니다
            </p>
            <p className='text-body1-long-regular text-sk-info'>
              고객의 사업에 알맞는 솔루션으로 어려웠던 홈페이지 준비를 도와드립니다
              <br />
              디테일한 기능으로 고객서비스를 제공해보세요 <br />
              편리한 사용과 편리한 운영을 동시에 서비스합니다
            </p>
          </div>
          <div className='flex items-center gap-36'>
            <img src={require('assets/images/skills-planning_image1.png')} alt='' />
            <img
              className='max-xl:hidden'
              src={require('assets/images/skills-planning_image2.png')}
              alt=''
            />
          </div>
        </div>
        <img
          className='absolute right-0 z-[11] max-md:hidden'
          src={require('assets/images/skills-planning_gradient.png')}
          alt=''
        />
      </div>
      <ContactFloatingButton />
    </div>
  )
}
